import { Component, OnInit, OnDestroy } from '@angular/core';
import { ShellService, IShellContext, INavSection } from './shell/shell.service';
import { Observable, timer, Subscription, combineLatest } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { environment } from '../environments/environment';
import { Title } from '@angular/platform-browser';
import { AuthService, IAuthState } from './share/services/auth.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy {
  shell: IShellContext;

  $lastUpdated: Subscription;

  $vm: Observable<IViewModel>;

  lastUpdatedValue: string;

  demoEnv = environment.demo;

  refresh(v: string) {
    if (!this.lastUpdatedValue)
      this.lastUpdatedValue = v;
    else if (this.lastUpdatedValue !== v)
      window.location.reload();
  }

  authState$: Observable<IAuthState>;

  /**
   *
   * @param shellService
   * @param http
   * @param titleService
   * @param authService
   * @param router
   * @param activatedRoute
   */
  constructor(public shellService: ShellService, private http: HttpClient, private titleService: Title, private authService: AuthService, private router: Router, private activatedRoute: ActivatedRoute) {
    this.shell = this.shellService.shellContext;

    this.titleService.setTitle(this.shell.title);
  }

  ngOnInit() {
      this.$lastUpdated = timer(0, 10000).pipe(
        switchMap(() => this.http.get(`./version.json?_cache_buster=${new Date().getTime()}`))).subscribe((r: any) => this.refresh(r.lastUpdated), e => console.log(e));

      this.authState$ = this.authService.watchState$();

      this.$vm = combineLatest([
        this.activatedRoute.queryParams,
        this.activatedRoute.url
      ]).pipe(
        map(([ params, url ]) => ({ params: params, url: url })),
        map(ctx => {
          this.shellService.showChrome = ctx.params['hide-chrome'] === 'yes' ? false
            : this.shellService.isOneTime() ? false
            : this.shellService.showChrome;

          const ret: IViewModel = {
            contactCenterSections: this.shellService.shellContext.navLinks.filter(nl => nl.menuName == 'contactCenter'),
            mainSections: this.shellService.shellContext.navLinks.filter(nl => nl.menuName == 'main')
          };
          return ret;
        })
      );
  }

  ngOnDestroy() {
    if (this.$lastUpdated)
      this.$lastUpdated.unsubscribe();
  }

  logout() {
    this.authService.logout();

    const tokenUserId: string = this.authService.tokenUserId();
    if (tokenUserId)
      this.router.navigateByUrl(`/login?uid=${tokenUserId}`);
    else
      this.router.navigateByUrl('/login');
  }

}

/**
 *
 */
interface IViewModel {
  contactCenterSections: INavSection[];
  mainSections: INavSection[];
}
